import "../style/page/Pharmacyissuelist.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  Pharmacylistissue,
  Pharmacylistissueid,
  sidebar,
} from "../redux/reducer/counterslice";
import { useEffect, useState, useMemo } from "react";
import { medicinetype } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
import ProductOrderForm from "../form/productorderform";
import Swal from "sweetalert2";
import MedicineTypeForm from "../form/medicinetypeform";

function MedicineType(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState("");


  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.Pharmacylistissue);
  const productid = useSelector((state) => state.counter.Pharmacylistissueid);
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const dropdownhandlechange = (e) => {
    if (e) {
      //   specialitynav("/SpecialityForm");
      dispatch(Pharmacylistissue("pharmacyissuelistedit"));
      dispatchid(Pharmacylistissueid(e));
    }
  };
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        axios({
          method: "get",
          url: medicinetype,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
          },
        })
          .then((res) => {
            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: medicinetype,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, productstate]);



  const columns = useMemo(
    () => [
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.created_date.slice(
                  0,
                  10
                )}
              >
                {row.row.original.created_date.slice(0, 10)}
              </p>
            </>
          );
        },
      },

      {
        Header: "Medicine Type",
        accessor: "",
        Cell: (row, index) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.medicine_type}
              >
                {row.row.original.medicine_type}
              </p>
            </>
          );
        },
      },
      {
        Header: "Description",
        accessor: "",
        Cell: (row, index) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.description}
              >
                {row.row.original.description}
              </p>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [popup]
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };


  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };


  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Medicine Type</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Medicine Type</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => {
                  dispatch(Pharmacylistissue("pharmacyissuelistcreate"));
                }}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}>
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {productstate == "pharmacyissuelistedit" ||
      productstate == "pharmacyissuelistcreate" ? (
        <>
<MedicineTypeForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}

/>
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default MedicineType;
